import { Component, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'viewer-icon-checkbox',
  templateUrl: './icon-checkbox.component.html',
  styleUrl: './icon-checkbox.component.scss',
})
export class IconCheckboxComponent implements AfterViewInit {
  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    const hostElement = this.elementRef.nativeElement;
    const inputElement = hostElement.querySelector('input[type="checkbox"]');

    if (inputElement) {
      hostElement.addEventListener('click', (event: any) => {
        // input 자체를 클릭한 경우는 제외 (이벤트 중복 방지)
        if (event.target !== inputElement) {
          (inputElement as HTMLInputElement).click();
        }
      });
    }
  }
}
